import { createSelector } from 'reselect';

const getRestaurants = (state) => state.businessApp.restaurants;
const getCompanies = (state) => state.budgetsApp.companies;
const getLoyaltyPrograms = (state) => state.loyaltyApp.loyaltyPrograms;

export const getPermittedRestaurants = createSelector(
    [getRestaurants],
    (restaurants) => {
        return restaurants;
    }
);

export const getPermittedCompanies = createSelector(
    [getCompanies],
    (companies) => {
        return companies;
    }
);

export const getPermittedLoyaltyPrograms = createSelector(
    [getLoyaltyPrograms],
    (loyaltyPrograms) => {
        return loyaltyPrograms;
    }
);

